var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var HeroSlider = require('components/hero-slider');

var AboutCommunitySources = function(el) {
  this.$el = $(el);
  this.$tabs = this.$el.find('.about-community-sources-item');
  this.$slider = this.$el.find('.about-community-sources-slider');
  
  this.slider = new HeroSlider(this.$slider[0], this.$tabs);

  $(window).on('vsc-page-ready vsc-page-resized', this.sizeBackground.bind(this));
};

AboutCommunitySources.prototype.sizeBackground = function() {
  var introHeight = this.$el.find('.about-community-sources-intro').outerHeight();
  this.$el.find('.hero-slide-background').css({
    top: (introHeight * -1)+'px'
  });
}

module.exports = AboutCommunitySources;